module.exports = __webpack_public_path__ + "static/img/column_img_11-2.60ef4c05.png";